module.exports = __webpack_public_path__ + "static/media/dex-contact-leads.5d24f680.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/dex-contact-leads.png
// module id = 194
// module chunks = 0